import React, { Fragment } from "react"
import ImageHome from "@components/MockableImages"

import MetaButton from "@components/MetaButton/version2"

const StatementModule = ({
  text,
  image,
  buttons,
  buttonWrapperClassName,
  theme,
  classes,
}) => {
  let background = ""
  let titleColor = "text-dblue"
  let color = ""

  switch (theme) {
    case "bg-dblue":
    case "blue-bg":
      background = "bg-dblue"
      color = "text-[#B9B8BD]"
      titleColor = "text-white"
      break
    case "white-bg":
      background = "bg-white"
      color = "text-dblue"
      titleColor = "text-dblue"
      break

    case "bg-lblue":
    case "gray-bg":
      background = "bg-lblue"
      color = "text-dblue"
      titleColor = "text-dblue"
      break
    case "gray2-bg":
      background = "bg-dbmarl"
      color = "text-white"
      titleColor = "text-white"
      break
  }

  const bgClass = `
    flex 
    flex-col 
    items-center 
    relative  
    z-10 
    py-[40px] 
    px-6
    
    desk:py-[100px]
    ${background} 
    ${classes?.background}  `

  const buttonWrapper = `
    flex 
    gap-3 
    justify-center 
    ${text.length > 1 ? " mt-[20px] " : ""}
    ${buttonWrapperClassName}`

  const titleClassDefault = `
    ${titleColor} 
    text-center 
    font-inter 
    ${text.length > 1 ? "mb-[8px]" : "mb-4"}
    text-[16px]   
    font-normal
    leading-[150%]
    md:w-[700px]
    md:text-[20px]
    desk:w-[960px]
    desk:text-[32px]
    desk:font-normal 
    desk:mb-8
     `

  const pClassDefault = ` 
    font-inter  
    text-[14px] 
    
    md:w-[700px]
    
    desk:w-[960px]
  

    ${color}
  `

  return (
    <div className="relative">
      {image && (
        <figure className="absolute inset-0 w-full h-full">
          <ImageHome image={image} />
        </figure>
      )}
      <div className={bgClass}>
        {text &&
          text.map((title, index) => (
            <Fragment key={title.text}>
              <h2
                key={index}
                className={
                  title.class +
                  (index === 0 ? " " + titleClassDefault : " " + pClassDefault)
                }
              >
                {title.text}
              </h2>
              {index < text.length - 1}
            </Fragment>
          ))}
        {buttons && (
          <div className={buttonWrapper}>
            {buttons.map(
              ({
                text,
                inverted,
                theme,
                fn,
                className,
                style,
                dataEvent,
                ...rest
              }) => (
                <MetaButton
                  key={text}
                  inverted={inverted}
                  theme={theme}
                  onClick={fn}
                  className={className}
                  style={style}
                  dataEvent={dataEvent}
                  {...rest}
                >
                  {text}
                </MetaButton>
              )
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default StatementModule
